import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import AdvancePricingOne from "../elements/advancePricing/AdvancePricingOne";
import FooterTwo from "../common/footer/FooterTwo";
import Copyright from "../common/footer/Copyright";
import Separator from "../elements/separator/Separator";
// import Service from "../elements/service/Service";
import CalltoActionEight from "../elements/calltoaction/CalltoActionEight";
import BlogClassicData from "../data/blog/BlogList.json";
import OfferPricing from "../elements/advancePricing/OfferPricing";
var BlogListData = BlogClassicData.slice(0, 3);

const SpecialOffer = () => {
  return (
    <>
      <SEO title="International Consulting" />
      <main id="main-content" className="page-wrapper" aria-label="Main content">
        <HeaderOne
          btnStyle="btn-small btn-icon"
          HeaderSTyle="header-transparent"
        />
         <div className="slider-area slider-style-1 height-850 bg_image dark-image" data-black-overlay="7" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-6.png)`}}>
                    <div className="light-image" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-7.jpg)`, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0, transition: 'opacity 0.3s ease-in-out'}}></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner pt--80 text-center">
                                    
                                    <h1 className="title2 display-one">Transform Your Digital Presence</h1> <br/>
                                    <div>
                                        <h3 className="rn-sub-badge"><span className="theme-gradient">Elevate your business with our comprehensive web
                        development and digital marketing solutions</span></h3>
                                    </div>
                                     <div className="button-group mt--40 mt_sm--20">
                                      <a
                                        className="btn-default btn-icon round btn-large"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="/services"
                                      >
                                        Explore Packages{""}
                                        <i className="icon">
                                          <FiArrowRight />
                                        </i>
                                      </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>

        {/* Start Slider area  */}

        {/* End Slider area  */}

        <Separator />
        {/* Start Elements Area  */}
        <div className="rwt-pricingtable-area rn-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <AdvancePricingOne />
              </div>
            </div>
          </div>
        </div>
        {/* End Elements Area  */}
        <Separator />

        {/* Start Elements Area  */}

        <SectionTitle textAlign="text-center" title="Our Services" />
        <div class="text-center mb-4 text-black">
          <p>Specialized solutions with 30 days support included</p>
        </div>
        <OfferPricing />
        {/* End Elements Area  */}

        <Separator />
        <Separator />
        {/* Start Call To Action Area  */}
        <div className="container">
          <div className="rwt-callto-action-area rn-section-gapBottom mt--60">
            <div className="wrapper">
              <CalltoActionEight />
            </div>
          </div>
        </div>

        {/* End Call To Action Area  */}

        <FooterTwo />
        <Copyright />
      </main>
    </>
  );
};

export default SpecialOffer;
